import { push } from 'react-router-redux'

import get from 'lodash/get'
import has from 'lodash/has'
import mapValues from 'lodash/mapValues'
import isNull from 'lodash/isNull'

import {
  clanPlayersOnlineStatus,
  playerFriendsOnlineStatus,
} from 'react-mt-bootstrap'

import {
  getClanInfoWithClanModesStatistics,
  getClanInfoWithStatistics,
} from 'containers/ClanManagement/proxy'

import { RequestsManager } from 'containers/ClanManagement/proxy/helpers'
import requestAccountInfo from 'state/actions/account'

import { startFetching, stopFetching } from './Fetching'

import { updateMembers } from './MembersOperation'

import { LOADING_DATA } from './translations'

import {
  BATTLE_TYPES,
  RANDOM_BATTLE_TYPES,
} from 'utils/clan_management/battles'
import { BLOCK_TYPES } from 'utils/clan_management/constants'
import { PERIOD_TYPES } from 'utils/clan_management/periods'

import { STRONGHOLD } from 'urls'

const webToClientStatusesMapping = {
    0: 'offline',
    1: 'online',
    2: 'busy',
}

export const CLAN_MANAGEMENT_START_FETCHING = 'CLAN_MANAGEMENT_START_FETCHING'
export const CLAN_MANAGEMENT_STOP_FETCHING = 'CLAN_MANAGEMENT_STOP_FETCHING'
export const CLAN_MANAGEMENT_CHANGE_BLOCK_TYPE =
  'CLAN_MANAGEMENT_CHANGE_BLOCK_TYPE'
export const CLAN_MANAGEMENT_CHANGE_PERIOD = 'CLAN_MANAGEMENT_CHANGE_PERIOD'
export const CLAN_MANAGEMENT_CHANGE_BATTLE_TYPE =
  'CLAN_MANAGEMENT_CHANGE_BATTLE_TYPE'
export const CLAN_MANAGEMENT_CHANGE_RANDOM_BATTLE_TYPE =
  'CLAN_MANAGEMENT_CHANGE_RANDOM_BATTLE_TYPE'
export const CLAN_MANAGEMENT_UPDATE = 'CLAN_MANAGEMENT_UPDATE'
export const CLAN_EXTENDED_INFO_UPDATE = 'CLAN_EXTENDED_INFO_UPDATE'
export const CLAN_MANAGEMENT_FETCH_ERROR = 'CLAN_MANAGEMENT_FETCH_ERROR'
export const CLAN_MANAGEMENT_TOGGLE_CLAN_IN_TRANSACTION =
  'CLAN_MANAGEMENT_TOGGLE_CLAN_IN_TRANSACTION'

export const OPEN_INVITES_APPLICATIONS_WINDOW =
  'OPEN_INVITES_APPLICATIONS_WINDOW'

export const startClanManagementFetching = () => ({
    type: CLAN_MANAGEMENT_START_FETCHING,
})

export const stopClanManagementFetching = () => ({
    type: CLAN_MANAGEMENT_STOP_FETCHING,
})

export const changeBlockType = blockType => ({
    type: CLAN_MANAGEMENT_CHANGE_BLOCK_TYPE,
    blockType,
})

export const changePeriod = period => ({
    type: CLAN_MANAGEMENT_CHANGE_PERIOD,
    period,
})

export const changeBattleType = battleType => ({
    type: CLAN_MANAGEMENT_CHANGE_BATTLE_TYPE,
    battleType,
})

export const changeRandomBattleType = randomBattleType => ({
    type: CLAN_MANAGEMENT_CHANGE_RANDOM_BATTLE_TYPE,
    randomBattleType,
})

export const updateClanManagement = (
  statisticsType,
  clan,
  members,
  statistics
) => ({
    type: CLAN_MANAGEMENT_UPDATE,
    statisticsType,
    clan,
    members,
    statistics,
})

export const clanManagementFetchError = e => {
  // eslint-disable-next-line no-console
    console.error(e)
    return {
        type: CLAN_MANAGEMENT_FETCH_ERROR,
    }
}

export const clanManagementToggleClanInTransaction = () => ({
    type: CLAN_MANAGEMENT_TOGGLE_CLAN_IN_TRANSACTION,
})

export const fetchWithSpinner = (dispatch, promise, fetchingText) => {
    dispatch(startFetching(fetchingText))
    promise
    .then(() => dispatch(stopFetching()))
    .catch(() => dispatch(stopFetching()))
    return promise
}

const updateMembersByStatuses = (
  members,
  onlineStatuses,
  friendsOnlineStatuses
) => {
    if (onlineStatuses) {
        onlineStatuses = mapValues(onlineStatuses, status => ({
            status: webToClientStatusesMapping[status],
        }))
    }
    return members.map(member => {
        member = {
            ...member,
        }
        if (onlineStatuses) {
            member.status = get(onlineStatuses, [member.id, 'status'])
        } else if (!has(member, 'status')) {
            member.status = webToClientStatusesMapping[0]
        }

        if (friendsOnlineStatuses) {
            member.isFriend = has(friendsOnlineStatuses, member.id)
        } else if (!has(member, 'isFriend')) {
            member.isFriend = false
        }

        return member
    })
}

export const fetchMembersStatuses = () => {
    return (dispatch, getState) => {
        return Promise.all([
            clanPlayersOnlineStatus(),
            playerFriendsOnlineStatus(),
        ]).then(([clanPlayerOnlineStatuses, playerFriendsOnlineStatuses]) => {
            if (
        isNull(clanPlayerOnlineStatuses) &&
        isNull(playerFriendsOnlineStatuses)
      )
                return

            const state = getState()
            const isFetching =
        state.clanManagement.fetchingCounter > 0 || state.fetching.counter > 0
            if (state.clanManagement.isError || isFetching) return

            const members = updateMembersByStatuses(
        state.members.members,
        clanPlayerOnlineStatuses,
        playerFriendsOnlineStatuses
      )
            dispatch(updateMembers(members))
        })
    }
}

export const fetchClanInfo = (withGlobalSpinner = false) => {
    return (dispatch, getState) => {
        dispatch(requestAccountInfo())
        dispatch(startClanManagementFetching())

        const state = getState()
        const blockType = state.clanManagement.blockType
        const id = state.account.id
        const clanId = state.clan.id
        const blockState = state.clanManagement[blockType]

        let battleType = blockState.battleType
        if (
      battleType === BATTLE_TYPES.RANDOM &&
      blockState.randomBattleType === RANDOM_BATTLE_TYPES.EPIC
    ) {
            battleType = BATTLE_TYPES.EPIC
        }

        const options = {
            accountId: id,
            period: blockState.period,
            battleType,
            urls: {
                gatewayHost: state.settings.gatewayHost,
                backendHost: state.settings.backendHost,
                clanUrl: `/clans/${clanId}/ex_info/`,
                spaUrl: '/accounts/names/',
                exporterUrl: '/accounts/stats/',
                wgrsUrl:
          blockState.period === PERIOD_TYPES.ALL ?
            void 0 :
            `/ratings/accounts/${battleType}/${blockState.period}/`,
                wgshUrl: '/game_api/journal/players/',
            },
        }

        const getClanInfo =
      blockType === BLOCK_TYPES.CLAN_MODES ?
        getClanInfoWithClanModesStatistics :
        getClanInfoWithStatistics

        const isAborted = RequestsManager.abortAll()
        if (isAborted) {
            dispatch(stopClanManagementFetching())
        }

        const promise = Promise.all([
            getClanInfo(options, true),
            clanPlayersOnlineStatus(),
            playerFriendsOnlineStatus(),
        ])
      .then(
        ([
          { clan, members, statistics },
          clanPlayerOnlineStatuses,
          playerFriendsOnlineStatuses,
        ]) => {
            members = updateMembersByStatuses(
            members,
            clanPlayerOnlineStatuses,
            playerFriendsOnlineStatuses
          )
            dispatch(updateClanManagement(blockType, clan, members, statistics))
        }
      )
      .catch(e => {
          dispatch(clanManagementFetchError(e))
          if (e && e.reason === 'account_is_not_in_clan') {
              dispatch(push(STRONGHOLD))
          }
      })

        return withGlobalSpinner ?
      fetchWithSpinner(dispatch, promise, LOADING_DATA) :
      promise
    }
}

export const openInvitesApplicationsWindow = () => ({
    type: OPEN_INVITES_APPLICATIONS_WINDOW,
    meta: {
        webToClient: {
            handler: 'openWindow',
            params: {
                windowId: 'clan_invites_window',
            },
        },
    },
})

export function requestClanExtendedInfo() {
    return async (dispatch, getState) => {
        const { settings, clan } = getState()
        const url = `${settings.gatewayHost}/clans/${clan.id}/ex_info/`

        const response = await fetch(url, { credentials: 'include' })
        if (!response.ok) return
        const payload = await response.json()

        dispatch({
            type: CLAN_EXTENDED_INFO_UPDATE,
            payload,
        })
    }
}



// WEBPACK FOOTER //
// ./state/actions/CMT/ClanManagement.js